/**
 * Generated by @openapi-codegen
 *
 * @version 2
 */
import * as reactQuery from "@tanstack/react-query";
import { useApiContext, ApiContext, queryKeyFn } from "./apiContext";
import type * as Fetcher from "./apiFetcher";
import { apiFetch } from "./apiFetcher";
import type * as Schemas from "./apiSchemas";

export type ApiGetEntityStakeholdersV2PathParams = {
  entityId: string;
};

export type ApiGetEntityStakeholdersV2Error = Fetcher.ErrorWrapper<undefined>;

export type ApiGetEntityStakeholdersV2Variables = {
  pathParams: ApiGetEntityStakeholdersV2PathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiGetEntityStakeholdersV2 = (
  variables: ApiGetEntityStakeholdersV2Variables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.EntityStakeholderResponseV2,
    ApiGetEntityStakeholdersV2Error,
    undefined,
    {},
    {},
    ApiGetEntityStakeholdersV2PathParams
  >({
    url: "/api/v2/resource/all_v2/{entityId}/stakeholders/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetEntityStakeholdersV2QueryKey = (
  variables: ApiGetEntityStakeholdersV2Variables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/api/v2/resource/all_v2/{entityId}/stakeholders/",
    operationId: "apiGetEntityStakeholdersV2",
    variables,
  });

export const useApiGetEntityStakeholdersV2 = <
  TData = Schemas.EntityStakeholderResponseV2,
>(
  variables: ApiGetEntityStakeholdersV2Variables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.EntityStakeholderResponseV2,
      ApiGetEntityStakeholdersV2Error,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/resource/all_v2/{entityId}/stakeholders/",
    operationId: "apiGetEntityStakeholdersV2",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.EntityStakeholderResponseV2,
    ApiGetEntityStakeholdersV2Error,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetEntityStakeholdersV2(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiGetEntityStakeholdersV2 = <
  TData = Schemas.EntityStakeholderResponseV2,
>(
  variables: ApiGetEntityStakeholdersV2Variables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.EntityStakeholderResponseV2,
      ApiGetEntityStakeholdersV2Error,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/resource/all_v2/{entityId}/stakeholders/",
    operationId: "apiGetEntityStakeholdersV2",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.EntityStakeholderResponseV2,
    ApiGetEntityStakeholdersV2Error,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetEntityStakeholdersV2(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ListCustomPropertiesV2QueryParams = {
  search_term?: string | null;
  source_filter?: string | null;
  /**
   * @default -created_at
   */
  order_by?: string;
  /**
   * @default 1
   */
  page?: number | null;
};

export type ListCustomPropertiesV2Error = Fetcher.ErrorWrapper<undefined>;

export type ListCustomPropertiesV2Variables = {
  queryParams?: ListCustomPropertiesV2QueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get paginated custom properties in the workspace.
 */
export const fetchListCustomPropertiesV2 = (
  variables: ListCustomPropertiesV2Variables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedCustomPropertyOut,
    ListCustomPropertiesV2Error,
    undefined,
    {},
    ListCustomPropertiesV2QueryParams,
    {}
  >({
    url: "/api/v2/resource/all_v2/custom_properties/v2/",
    method: "get",
    ...variables,
    signal,
  });

export const listCustomPropertiesV2QueryKey = (
  variables: ListCustomPropertiesV2Variables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/api/v2/resource/all_v2/custom_properties/v2/",
    operationId: "listCustomPropertiesV2",
    variables,
  });

/**
 * Get paginated custom properties in the workspace.
 */
export const useListCustomPropertiesV2 = <
  TData = Schemas.PagedCustomPropertyOut,
>(
  variables: ListCustomPropertiesV2Variables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedCustomPropertyOut,
      ListCustomPropertiesV2Error,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/resource/all_v2/custom_properties/v2/",
    operationId: "listCustomPropertiesV2",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedCustomPropertyOut,
    ListCustomPropertiesV2Error,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchListCustomPropertiesV2({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get paginated custom properties in the workspace.
 */
export const useSuspenseListCustomPropertiesV2 = <
  TData = Schemas.PagedCustomPropertyOut,
>(
  variables: ListCustomPropertiesV2Variables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedCustomPropertyOut,
      ListCustomPropertiesV2Error,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/resource/all_v2/custom_properties/v2/",
    operationId: "listCustomPropertiesV2",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedCustomPropertyOut,
    ListCustomPropertiesV2Error,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchListCustomPropertiesV2({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiSuperuserGetQueryBackgroundJobPathParams = {
  executionId: string;
};

export type ApiSuperuserGetQueryBackgroundJobError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiSuperuserGetQueryBackgroundJobVariables = {
  pathParams: ApiSuperuserGetQueryBackgroundJobPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiSuperuserGetQueryBackgroundJob = (
  variables: ApiSuperuserGetQueryBackgroundJobVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.QueryExecutionOut,
    ApiSuperuserGetQueryBackgroundJobError,
    undefined,
    {},
    {},
    ApiSuperuserGetQueryBackgroundJobPathParams
  >({
    url: "/api/v2/admin/metric/execution/{executionId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiSuperuserGetQueryBackgroundJobQueryKey = (
  variables: ApiSuperuserGetQueryBackgroundJobVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/api/v2/admin/metric/execution/{executionId}/",
    operationId: "apiSuperuserGetQueryBackgroundJob",
    variables,
  });

export const useApiSuperuserGetQueryBackgroundJob = <
  TData = Schemas.QueryExecutionOut,
>(
  variables: ApiSuperuserGetQueryBackgroundJobVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.QueryExecutionOut,
      ApiSuperuserGetQueryBackgroundJobError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/admin/metric/execution/{executionId}/",
    operationId: "apiSuperuserGetQueryBackgroundJob",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.QueryExecutionOut,
    ApiSuperuserGetQueryBackgroundJobError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiSuperuserGetQueryBackgroundJob(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseApiSuperuserGetQueryBackgroundJob = <
  TData = Schemas.QueryExecutionOut,
>(
  variables: ApiSuperuserGetQueryBackgroundJobVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.QueryExecutionOut,
      ApiSuperuserGetQueryBackgroundJobError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/admin/metric/execution/{executionId}/",
    operationId: "apiSuperuserGetQueryBackgroundJob",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.QueryExecutionOut,
    ApiSuperuserGetQueryBackgroundJobError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiSuperuserGetQueryBackgroundJob(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type StripeWebhookV2Error = Fetcher.ErrorWrapper<undefined>;

export type StripeWebhookV2Response = {
  [key: string]: any;
};

export type StripeWebhookV2Variables = ApiContext["fetcherOptions"];

/**
 * Handle Stripe webhook events, specifically setup_intent.succeeded.
 * Stores card information in the workspace when a payment method is successfully set up.
 */
export const fetchStripeWebhookV2 = (
  variables: StripeWebhookV2Variables,
  signal?: AbortSignal,
) =>
  apiFetch<
    StripeWebhookV2Response,
    StripeWebhookV2Error,
    undefined,
    {},
    {},
    {}
  >({ url: "/api/v2/stripe/webhook/", method: "post", ...variables, signal });

/**
 * Handle Stripe webhook events, specifically setup_intent.succeeded.
 * Stores card information in the workspace when a payment method is successfully set up.
 */
export const useStripeWebhookV2 = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      StripeWebhookV2Response,
      StripeWebhookV2Error,
      StripeWebhookV2Variables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    StripeWebhookV2Response,
    StripeWebhookV2Error,
    StripeWebhookV2Variables
  >({
    mutationFn: (variables: StripeWebhookV2Variables) =>
      fetchStripeWebhookV2({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiListTeamsV2QueryParams = {
  /**
   * @default false
   */
  include_archived?: boolean;
  /**
   * @default false
   */
  only_joined?: boolean;
  /**
   * @default false
   */
  only_write?: boolean;
};

export type ApiListTeamsV2Error = Fetcher.ErrorWrapper<undefined>;

export type ApiListTeamsV2Response = Schemas.TeamOut[];

export type ApiListTeamsV2Variables = {
  queryParams?: ApiListTeamsV2QueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get a list of teams in the workspace.
 */
export const fetchApiListTeamsV2 = (
  variables: ApiListTeamsV2Variables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiListTeamsV2Response,
    ApiListTeamsV2Error,
    undefined,
    {},
    ApiListTeamsV2QueryParams,
    {}
  >({ url: "/api/v2/auth/teams/", method: "get", ...variables, signal });

export const apiListTeamsV2QueryKey = (
  variables: ApiListTeamsV2Variables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/api/v2/auth/teams/",
    operationId: "apiListTeamsV2",
    variables,
  });

/**
 * Get a list of teams in the workspace.
 */
export const useApiListTeamsV2 = <TData = ApiListTeamsV2Response,>(
  variables: ApiListTeamsV2Variables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiListTeamsV2Response,
      ApiListTeamsV2Error,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/auth/teams/",
    operationId: "apiListTeamsV2",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiListTeamsV2Response,
    ApiListTeamsV2Error,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListTeamsV2({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get a list of teams in the workspace.
 */
export const useSuspenseApiListTeamsV2 = <TData = ApiListTeamsV2Response,>(
  variables: ApiListTeamsV2Variables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiListTeamsV2Response,
      ApiListTeamsV2Error,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/auth/teams/",
    operationId: "apiListTeamsV2",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiListTeamsV2Response,
    ApiListTeamsV2Error,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListTeamsV2({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiListApiKeysV2QueryParams = {
  /**
   * @default 1
   */
  page?: number | null;
};

export type ApiListApiKeysV2Error = Fetcher.ErrorWrapper<undefined>;

export type ApiListApiKeysV2Variables = {
  queryParams?: ApiListApiKeysV2QueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Lists API keys for the current workspace (v2).
 *
 * Returns enhanced information about API keys including user details and last usage.
 */
export const fetchApiListApiKeysV2 = (
  variables: ApiListApiKeysV2Variables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.PagedApiKeyOutV2,
    ApiListApiKeysV2Error,
    undefined,
    {},
    ApiListApiKeysV2QueryParams,
    {}
  >({ url: "/api/v2/auth/api_keys/", method: "get", ...variables, signal });

export const apiListApiKeysV2QueryKey = (
  variables: ApiListApiKeysV2Variables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/api/v2/auth/api_keys/",
    operationId: "apiListApiKeysV2",
    variables,
  });

/**
 * Lists API keys for the current workspace (v2).
 *
 * Returns enhanced information about API keys including user details and last usage.
 */
export const useApiListApiKeysV2 = <TData = Schemas.PagedApiKeyOutV2,>(
  variables: ApiListApiKeysV2Variables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PagedApiKeyOutV2,
      ApiListApiKeysV2Error,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/auth/api_keys/",
    operationId: "apiListApiKeysV2",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.PagedApiKeyOutV2,
    ApiListApiKeysV2Error,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListApiKeysV2({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Lists API keys for the current workspace (v2).
 *
 * Returns enhanced information about API keys including user details and last usage.
 */
export const useSuspenseApiListApiKeysV2 = <TData = Schemas.PagedApiKeyOutV2,>(
  variables: ApiListApiKeysV2Variables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.PagedApiKeyOutV2,
      ApiListApiKeysV2Error,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/auth/api_keys/",
    operationId: "apiListApiKeysV2",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.PagedApiKeyOutV2,
    ApiListApiKeysV2Error,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListApiKeysV2({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetWorkspaceFeatureAccessError = Fetcher.ErrorWrapper<undefined>;

export type GetWorkspaceFeatureAccessVariables = ApiContext["fetcherOptions"];

/**
 * Feature access for the workspace. This endpoint is used by the frontend to
 * determine if the workspace has access to certain features.
 *
 * This endpoint manually handles authentication using CookieAuth to derive the workspace.
 */
export const fetchGetWorkspaceFeatureAccess = (
  variables: GetWorkspaceFeatureAccessVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.FeatureAccess,
    GetWorkspaceFeatureAccessError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/api/v2/workspace/feature_access/v2/",
    method: "get",
    ...variables,
    signal,
  });

export const getWorkspaceFeatureAccessQueryKey = (
  variables: GetWorkspaceFeatureAccessVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/api/v2/workspace/feature_access/v2/",
    operationId: "getWorkspaceFeatureAccess",
    variables,
  });

/**
 * Feature access for the workspace. This endpoint is used by the frontend to
 * determine if the workspace has access to certain features.
 *
 * This endpoint manually handles authentication using CookieAuth to derive the workspace.
 */
export const useGetWorkspaceFeatureAccess = <TData = Schemas.FeatureAccess,>(
  variables: GetWorkspaceFeatureAccessVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.FeatureAccess,
      GetWorkspaceFeatureAccessError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/workspace/feature_access/v2/",
    operationId: "getWorkspaceFeatureAccess",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.FeatureAccess,
    GetWorkspaceFeatureAccessError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetWorkspaceFeatureAccess(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Feature access for the workspace. This endpoint is used by the frontend to
 * determine if the workspace has access to certain features.
 *
 * This endpoint manually handles authentication using CookieAuth to derive the workspace.
 */
export const useSuspenseGetWorkspaceFeatureAccess = <
  TData = Schemas.FeatureAccess,
>(
  variables: GetWorkspaceFeatureAccessVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.FeatureAccess,
      GetWorkspaceFeatureAccessError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/workspace/feature_access/v2/",
    operationId: "getWorkspaceFeatureAccess",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.FeatureAccess,
    GetWorkspaceFeatureAccessError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetWorkspaceFeatureAccess(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiMeError = Fetcher.ErrorWrapper<undefined>;

export type ApiMeVariables = ApiContext["fetcherOptions"];

/**
 * Returns the current user's complete profile data (v1).
 *
 * This endpoint migrates the DRF /user/me/ endpoint to Django Ninja.
 * Handles user state updates and triggers async metadata updates.
 *
 * Performance considerations:
 * - Uses select_related for workspace to avoid N+1 queries
 * - Uses prefetch_related for many-to-many fields
 * - Async task for metadata update to avoid blocking
 *
 * Returns:
 *     UserOut: Complete user profile with workspace, teams, groups, and bookmarks
 */
export const fetchApiMe = (variables: ApiMeVariables, signal?: AbortSignal) =>
  apiFetch<Schemas.UserOut, ApiMeError, undefined, {}, {}, {}>({
    url: "/api/v2/auth/user/me/",
    method: "get",
    ...variables,
    signal,
  });

export const apiMeQueryKey = (variables: ApiMeVariables): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/api/v2/auth/user/me/",
    operationId: "apiMe",
    variables,
  });

/**
 * Returns the current user's complete profile data (v1).
 *
 * This endpoint migrates the DRF /user/me/ endpoint to Django Ninja.
 * Handles user state updates and triggers async metadata updates.
 *
 * Performance considerations:
 * - Uses select_related for workspace to avoid N+1 queries
 * - Uses prefetch_related for many-to-many fields
 * - Async task for metadata update to avoid blocking
 *
 * Returns:
 *     UserOut: Complete user profile with workspace, teams, groups, and bookmarks
 */
export const useApiMe = <TData = Schemas.UserOut,>(
  variables: ApiMeVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.UserOut, ApiMeError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/auth/user/me/",
    operationId: "apiMe",
    variables,
  });
  const result = reactQuery.useQuery<Schemas.UserOut, ApiMeError, TData>({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiMe({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Returns the current user's complete profile data (v1).
 *
 * This endpoint migrates the DRF /user/me/ endpoint to Django Ninja.
 * Handles user state updates and triggers async metadata updates.
 *
 * Performance considerations:
 * - Uses select_related for workspace to avoid N+1 queries
 * - Uses prefetch_related for many-to-many fields
 * - Async task for metadata update to avoid blocking
 *
 * Returns:
 *     UserOut: Complete user profile with workspace, teams, groups, and bookmarks
 */
export const useSuspenseApiMe = <TData = Schemas.UserOut,>(
  variables: ApiMeVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<Schemas.UserOut, ApiMeError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/auth/user/me/",
    operationId: "apiMe",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.UserOut,
    ApiMeError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiMe({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetIntercomIdentityTokenError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetIntercomIdentityTokenVariables = ApiContext["fetcherOptions"];

/**
 * Returns an Intercom identity verification token for the current user.
 *
 * This endpoint generates an HMAC-based identity verification token that
 * prevents user impersonation when booting Intercom. The token is generated
 * server-side using the user's email as the identifier.
 *
 * Returns:
 *     IntercomIdentityTokenOut: Contains the identity verification token
 *
 * Raises:
 *     HttpError: If identity verification secret is not configured
 */
export const fetchApiGetIntercomIdentityToken = (
  variables: ApiGetIntercomIdentityTokenVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.IntercomIdentityTokenOut,
    ApiGetIntercomIdentityTokenError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/api/v2/auth/user/intercom-identity-token/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetIntercomIdentityTokenQueryKey = (
  variables: ApiGetIntercomIdentityTokenVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/api/v2/auth/user/intercom-identity-token/",
    operationId: "apiGetIntercomIdentityToken",
    variables,
  });

/**
 * Returns an Intercom identity verification token for the current user.
 *
 * This endpoint generates an HMAC-based identity verification token that
 * prevents user impersonation when booting Intercom. The token is generated
 * server-side using the user's email as the identifier.
 *
 * Returns:
 *     IntercomIdentityTokenOut: Contains the identity verification token
 *
 * Raises:
 *     HttpError: If identity verification secret is not configured
 */
export const useApiGetIntercomIdentityToken = <
  TData = Schemas.IntercomIdentityTokenOut,
>(
  variables: ApiGetIntercomIdentityTokenVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.IntercomIdentityTokenOut,
      ApiGetIntercomIdentityTokenError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/auth/user/intercom-identity-token/",
    operationId: "apiGetIntercomIdentityToken",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.IntercomIdentityTokenOut,
    ApiGetIntercomIdentityTokenError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetIntercomIdentityToken(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Returns an Intercom identity verification token for the current user.
 *
 * This endpoint generates an HMAC-based identity verification token that
 * prevents user impersonation when booting Intercom. The token is generated
 * server-side using the user's email as the identifier.
 *
 * Returns:
 *     IntercomIdentityTokenOut: Contains the identity verification token
 *
 * Raises:
 *     HttpError: If identity verification secret is not configured
 */
export const useSuspenseApiGetIntercomIdentityToken = <
  TData = Schemas.IntercomIdentityTokenOut,
>(
  variables: ApiGetIntercomIdentityTokenVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.IntercomIdentityTokenOut,
      ApiGetIntercomIdentityTokenError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/auth/user/intercom-identity-token/",
    operationId: "apiGetIntercomIdentityToken",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.IntercomIdentityTokenOut,
    ApiGetIntercomIdentityTokenError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetIntercomIdentityToken(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetWorkspaceLimitsError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetWorkspaceLimitsVariables = ApiContext["fetcherOptions"];

/**
 * Get billing limits for the workspace.
 *
 * This endpoint is used by the frontend to determine if the user has reached
 * their limits for editors, viewers, and integrations.
 *
 * The request is forwarded to a CloudFlare worker that processes billing telemetry.
 *
 * Performance note: This makes an external HTTP call to the telemetry service,
 * which may take ~100-300ms depending on network latency.
 *
 * Returns:
 *     dict: Billing limits data from the telemetry service
 */
export const fetchApiGetWorkspaceLimits = (
  variables: ApiGetWorkspaceLimitsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LimitsOut,
    ApiGetWorkspaceLimitsError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/api/v2/workspace/seats/limits/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetWorkspaceLimitsQueryKey = (
  variables: ApiGetWorkspaceLimitsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/api/v2/workspace/seats/limits/",
    operationId: "apiGetWorkspaceLimits",
    variables,
  });

/**
 * Get billing limits for the workspace.
 *
 * This endpoint is used by the frontend to determine if the user has reached
 * their limits for editors, viewers, and integrations.
 *
 * The request is forwarded to a CloudFlare worker that processes billing telemetry.
 *
 * Performance note: This makes an external HTTP call to the telemetry service,
 * which may take ~100-300ms depending on network latency.
 *
 * Returns:
 *     dict: Billing limits data from the telemetry service
 */
export const useApiGetWorkspaceLimits = <TData = Schemas.LimitsOut,>(
  variables: ApiGetWorkspaceLimitsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LimitsOut,
      ApiGetWorkspaceLimitsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/workspace/seats/limits/",
    operationId: "apiGetWorkspaceLimits",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.LimitsOut,
    ApiGetWorkspaceLimitsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetWorkspaceLimits({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get billing limits for the workspace.
 *
 * This endpoint is used by the frontend to determine if the user has reached
 * their limits for editors, viewers, and integrations.
 *
 * The request is forwarded to a CloudFlare worker that processes billing telemetry.
 *
 * Performance note: This makes an external HTTP call to the telemetry service,
 * which may take ~100-300ms depending on network latency.
 *
 * Returns:
 *     dict: Billing limits data from the telemetry service
 */
export const useSuspenseApiGetWorkspaceLimits = <TData = Schemas.LimitsOut,>(
  variables: ApiGetWorkspaceLimitsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.LimitsOut,
      ApiGetWorkspaceLimitsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/workspace/seats/limits/",
    operationId: "apiGetWorkspaceLimits",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.LimitsOut,
    ApiGetWorkspaceLimitsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetWorkspaceLimits({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetBillingInfoError = Fetcher.ErrorWrapper<undefined>;

export type GetBillingInfoVariables = ApiContext["fetcherOptions"];

/**
 * Get billing information for the workspace including plan details, seat limits, and trial status.
 */
export const fetchGetBillingInfo = (
  variables: GetBillingInfoVariables,
  signal?: AbortSignal,
) =>
  apiFetch<Schemas.BillingInfoOut, GetBillingInfoError, undefined, {}, {}, {}>({
    url: "/api/v2/workspace/billing/info/",
    method: "get",
    ...variables,
    signal,
  });

export const getBillingInfoQueryKey = (
  variables: GetBillingInfoVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/api/v2/workspace/billing/info/",
    operationId: "getBillingInfo",
    variables,
  });

/**
 * Get billing information for the workspace including plan details, seat limits, and trial status.
 */
export const useGetBillingInfo = <TData = Schemas.BillingInfoOut,>(
  variables: GetBillingInfoVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.BillingInfoOut,
      GetBillingInfoError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/workspace/billing/info/",
    operationId: "getBillingInfo",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.BillingInfoOut,
    GetBillingInfoError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetBillingInfo({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get billing information for the workspace including plan details, seat limits, and trial status.
 */
export const useSuspenseGetBillingInfo = <TData = Schemas.BillingInfoOut,>(
  variables: GetBillingInfoVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.BillingInfoOut,
      GetBillingInfoError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/workspace/billing/info/",
    operationId: "getBillingInfo",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.BillingInfoOut,
    GetBillingInfoError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetBillingInfo({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiBulkImportError = Fetcher.ErrorWrapper<undefined>;

export type ApiBulkImportRequestBody = {
  /**
   * @format binary
   */
  file: Blob;
};

export type ApiBulkImportVariables = {
  body: ApiBulkImportRequestBody;
} & ApiContext["fetcherOptions"];

/**
 * Upload a CSV file for bulk import of metadata.
 *
 * Returns a background job with a presigned URL to access the results file.
 */
export const fetchApiBulkImport = (
  variables: ApiBulkImportVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.BulkImportResponse,
    ApiBulkImportError,
    ApiBulkImportRequestBody,
    {},
    {},
    {}
  >({ url: "/api/v2/metadata/", method: "post", ...variables, signal });

/**
 * Upload a CSV file for bulk import of metadata.
 *
 * Returns a background job with a presigned URL to access the results file.
 */
export const useApiBulkImport = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BulkImportResponse,
      ApiBulkImportError,
      ApiBulkImportVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.BulkImportResponse,
    ApiBulkImportError,
    ApiBulkImportVariables
  >({
    mutationFn: (variables: ApiBulkImportVariables) =>
      fetchApiBulkImport({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiUpdateIntegrationGroupVisibilityPathParams = {
  integrationId: string;
};

export type ApiUpdateIntegrationGroupVisibilityError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: string;
}>;

export type ApiUpdateIntegrationGroupVisibilityResponse =
  Schemas.GroupItemSettingSchema[];

export type ApiUpdateIntegrationGroupVisibilityVariables = {
  body: Schemas.UpdateGroupVisibilityRequest;
  pathParams: ApiUpdateIntegrationGroupVisibilityPathParams;
} & ApiContext["fetcherOptions"];

/**
 * This endpoint is used to update the visibility of a group in the integration.
 * It will update the group settings for the integration and save the changes.
 * It will also create an activity log entry for the change.
 */
export const fetchApiUpdateIntegrationGroupVisibility = (
  variables: ApiUpdateIntegrationGroupVisibilityVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiUpdateIntegrationGroupVisibilityResponse,
    ApiUpdateIntegrationGroupVisibilityError,
    Schemas.UpdateGroupVisibilityRequest,
    {},
    {},
    ApiUpdateIntegrationGroupVisibilityPathParams
  >({
    url: "/api/v2/integration_v2/integrations/{integrationId}/group_settings/visibility/",
    method: "patch",
    ...variables,
    signal,
  });

/**
 * This endpoint is used to update the visibility of a group in the integration.
 * It will update the group settings for the integration and save the changes.
 * It will also create an activity log entry for the change.
 */
export const useApiUpdateIntegrationGroupVisibility = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ApiUpdateIntegrationGroupVisibilityResponse,
      ApiUpdateIntegrationGroupVisibilityError,
      ApiUpdateIntegrationGroupVisibilityVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    ApiUpdateIntegrationGroupVisibilityResponse,
    ApiUpdateIntegrationGroupVisibilityError,
    ApiUpdateIntegrationGroupVisibilityVariables
  >({
    mutationFn: (variables: ApiUpdateIntegrationGroupVisibilityVariables) =>
      fetchApiUpdateIntegrationGroupVisibility({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiUpdateIntegrationGroupTeamsAssignedPathParams = {
  integrationId: string;
};

export type ApiUpdateIntegrationGroupTeamsAssignedError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: string;
}>;

export type ApiUpdateIntegrationGroupTeamsAssignedResponse =
  Schemas.GroupItemSettingSchema[];

export type ApiUpdateIntegrationGroupTeamsAssignedVariables = {
  body: Schemas.UpdateGroupTeamsAssignedRequest;
  pathParams: ApiUpdateIntegrationGroupTeamsAssignedPathParams;
} & ApiContext["fetcherOptions"];

export const fetchApiUpdateIntegrationGroupTeamsAssigned = (
  variables: ApiUpdateIntegrationGroupTeamsAssignedVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiUpdateIntegrationGroupTeamsAssignedResponse,
    ApiUpdateIntegrationGroupTeamsAssignedError,
    Schemas.UpdateGroupTeamsAssignedRequest,
    {},
    {},
    ApiUpdateIntegrationGroupTeamsAssignedPathParams
  >({
    url: "/api/v2/integration_v2/integrations/{integrationId}/group_settings/teams-assigned/",
    method: "patch",
    ...variables,
    signal,
  });

export const useApiUpdateIntegrationGroupTeamsAssigned = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      ApiUpdateIntegrationGroupTeamsAssignedResponse,
      ApiUpdateIntegrationGroupTeamsAssignedError,
      ApiUpdateIntegrationGroupTeamsAssignedVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    ApiUpdateIntegrationGroupTeamsAssignedResponse,
    ApiUpdateIntegrationGroupTeamsAssignedError,
    ApiUpdateIntegrationGroupTeamsAssignedVariables
  >({
    mutationFn: (variables: ApiUpdateIntegrationGroupTeamsAssignedVariables) =>
      fetchApiUpdateIntegrationGroupTeamsAssigned({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiCatalogTreeV3GetIntegrationsQueryParams = {
  team_id: string;
};

export type ApiCatalogTreeV3GetIntegrationsError =
  Fetcher.ErrorWrapper<undefined>;

export type ApiCatalogTreeV3GetIntegrationsResponse =
  Schemas.LiteIntegrationOut[];

export type ApiCatalogTreeV3GetIntegrationsVariables = {
  queryParams: ApiCatalogTreeV3GetIntegrationsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * Get integrations for catalog tree display with enhanced team access logic.
 */
export const fetchApiCatalogTreeV3GetIntegrations = (
  variables: ApiCatalogTreeV3GetIntegrationsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiCatalogTreeV3GetIntegrationsResponse,
    ApiCatalogTreeV3GetIntegrationsError,
    undefined,
    {},
    ApiCatalogTreeV3GetIntegrationsQueryParams,
    {}
  >({
    url: "/api/v2/integration_v2/integrations/catalogtree/list/",
    method: "get",
    ...variables,
    signal,
  });

export const apiCatalogTreeV3GetIntegrationsQueryKey = (
  variables: ApiCatalogTreeV3GetIntegrationsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/api/v2/integration_v2/integrations/catalogtree/list/",
    operationId: "apiCatalogTreeV3GetIntegrations",
    variables,
  });

/**
 * Get integrations for catalog tree display with enhanced team access logic.
 */
export const useApiCatalogTreeV3GetIntegrations = <
  TData = ApiCatalogTreeV3GetIntegrationsResponse,
>(
  variables: ApiCatalogTreeV3GetIntegrationsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiCatalogTreeV3GetIntegrationsResponse,
      ApiCatalogTreeV3GetIntegrationsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/integration_v2/integrations/catalogtree/list/",
    operationId: "apiCatalogTreeV3GetIntegrations",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiCatalogTreeV3GetIntegrationsResponse,
    ApiCatalogTreeV3GetIntegrationsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiCatalogTreeV3GetIntegrations(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get integrations for catalog tree display with enhanced team access logic.
 */
export const useSuspenseApiCatalogTreeV3GetIntegrations = <
  TData = ApiCatalogTreeV3GetIntegrationsResponse,
>(
  variables: ApiCatalogTreeV3GetIntegrationsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiCatalogTreeV3GetIntegrationsResponse,
      ApiCatalogTreeV3GetIntegrationsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/integration_v2/integrations/catalogtree/list/",
    operationId: "apiCatalogTreeV3GetIntegrations",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiCatalogTreeV3GetIntegrationsResponse,
    ApiCatalogTreeV3GetIntegrationsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiCatalogTreeV3GetIntegrations(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetSlackConversationsListError = Fetcher.ErrorWrapper<undefined>;

export type GetSlackConversationsListResponse = Schemas.SlackConverstationOut[];

export type GetSlackConversationsListVariables = ApiContext["fetcherOptions"];

/**
 * Use this endpoint to list all available Slack conversations or channels.
 */
export const fetchGetSlackConversationsList = (
  variables: GetSlackConversationsListVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    GetSlackConversationsListResponse,
    GetSlackConversationsListError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/api/v2/integration_v2/slack/conversations/list/",
    method: "get",
    ...variables,
    signal,
  });

export const getSlackConversationsListQueryKey = (
  variables: GetSlackConversationsListVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/api/v2/integration_v2/slack/conversations/list/",
    operationId: "getSlackConversationsList",
    variables,
  });

/**
 * Use this endpoint to list all available Slack conversations or channels.
 */
export const useGetSlackConversationsList = <
  TData = GetSlackConversationsListResponse,
>(
  variables: GetSlackConversationsListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetSlackConversationsListResponse,
      GetSlackConversationsListError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/integration_v2/slack/conversations/list/",
    operationId: "getSlackConversationsList",
    variables,
  });
  const result = reactQuery.useQuery<
    GetSlackConversationsListResponse,
    GetSlackConversationsListError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetSlackConversationsList(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Use this endpoint to list all available Slack conversations or channels.
 */
export const useSuspenseGetSlackConversationsList = <
  TData = GetSlackConversationsListResponse,
>(
  variables: GetSlackConversationsListVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      GetSlackConversationsListResponse,
      GetSlackConversationsListError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/integration_v2/slack/conversations/list/",
    operationId: "getSlackConversationsList",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    GetSlackConversationsListResponse,
    GetSlackConversationsListError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetSlackConversationsList(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiGetLineageFlowMetadataV2Error = Fetcher.ErrorWrapper<undefined>;

export type ApiGetLineageFlowMetadataV2Variables = {
  body: Schemas.LineageFlowMetadataIn;
} & ApiContext["fetcherOptions"];

export const fetchApiGetLineageFlowMetadataV2 = (
  variables: ApiGetLineageFlowMetadataV2Variables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.LineageFlowMetadataOutV2,
    ApiGetLineageFlowMetadataV2Error,
    Schemas.LineageFlowMetadataIn,
    {},
    {},
    {}
  >({
    url: "/api/v2/lineage/flow/metadata/",
    method: "post",
    ...variables,
    signal,
  });

export const useApiGetLineageFlowMetadataV2 = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LineageFlowMetadataOutV2,
      ApiGetLineageFlowMetadataV2Error,
      ApiGetLineageFlowMetadataV2Variables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.LineageFlowMetadataOutV2,
    ApiGetLineageFlowMetadataV2Error,
    ApiGetLineageFlowMetadataV2Variables
  >({
    mutationFn: (variables: ApiGetLineageFlowMetadataV2Variables) =>
      fetchApiGetLineageFlowMetadataV2({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetCreationQueryV2PathParams = {
  entityId: string;
};

export type ApiGetCreationQueryV2Error = Fetcher.ErrorWrapper<undefined>;

export type ApiGetCreationQueryV2Response = Schemas.LiteQueryOut[];

export type ApiGetCreationQueryV2Variables = {
  pathParams: ApiGetCreationQueryV2PathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get the creation queries of an entity.
 */
export const fetchApiGetCreationQueryV2 = (
  variables: ApiGetCreationQueryV2Variables,
  signal?: AbortSignal,
) =>
  apiFetch<
    ApiGetCreationQueryV2Response,
    ApiGetCreationQueryV2Error,
    undefined,
    {},
    {},
    ApiGetCreationQueryV2PathParams
  >({
    url: "/api/v2/query/queries/creation_query/{entityId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetCreationQueryV2QueryKey = (
  variables: ApiGetCreationQueryV2Variables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/api/v2/query/queries/creation_query/{entityId}/",
    operationId: "apiGetCreationQueryV2",
    variables,
  });

/**
 * Get the creation queries of an entity.
 */
export const useApiGetCreationQueryV2 = <
  TData = ApiGetCreationQueryV2Response,
>(
  variables: ApiGetCreationQueryV2Variables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiGetCreationQueryV2Response,
      ApiGetCreationQueryV2Error,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/query/queries/creation_query/{entityId}/",
    operationId: "apiGetCreationQueryV2",
    variables,
  });
  const result = reactQuery.useQuery<
    ApiGetCreationQueryV2Response,
    ApiGetCreationQueryV2Error,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetCreationQueryV2({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get the creation queries of an entity.
 */
export const useSuspenseApiGetCreationQueryV2 = <
  TData = ApiGetCreationQueryV2Response,
>(
  variables: ApiGetCreationQueryV2Variables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      ApiGetCreationQueryV2Response,
      ApiGetCreationQueryV2Error,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/query/queries/creation_query/{entityId}/",
    operationId: "apiGetCreationQueryV2",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    ApiGetCreationQueryV2Response,
    ApiGetCreationQueryV2Error,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetCreationQueryV2({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type GetIncludedInQualityGovernanceError =
  Fetcher.ErrorWrapper<undefined>;

export type GetIncludedInQualityGovernanceVariables =
  ApiContext["fetcherOptions"];

export const fetchGetIncludedInQualityGovernance = (
  variables: GetIncludedInQualityGovernanceVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.CatalogRule,
    GetIncludedInQualityGovernanceError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/api/v2/quality/preferences/governance/included/",
    method: "get",
    ...variables,
    signal,
  });

export const getIncludedInQualityGovernanceQueryKey = (
  variables: GetIncludedInQualityGovernanceVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/api/v2/quality/preferences/governance/included/",
    operationId: "getIncludedInQualityGovernance",
    variables,
  });

export const useGetIncludedInQualityGovernance = <TData = Schemas.CatalogRule,>(
  variables: GetIncludedInQualityGovernanceVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.CatalogRule,
      GetIncludedInQualityGovernanceError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/quality/preferences/governance/included/",
    operationId: "getIncludedInQualityGovernance",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.CatalogRule,
    GetIncludedInQualityGovernanceError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetIncludedInQualityGovernance(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetIncludedInQualityGovernance = <
  TData = Schemas.CatalogRule,
>(
  variables: GetIncludedInQualityGovernanceVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.CatalogRule,
      GetIncludedInQualityGovernanceError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/quality/preferences/governance/included/",
    operationId: "getIncludedInQualityGovernance",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.CatalogRule,
    GetIncludedInQualityGovernanceError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetIncludedInQualityGovernance(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type SetIncludedInQualityGovernanceError =
  Fetcher.ErrorWrapper<undefined>;

export type SetIncludedInQualityGovernanceVariables = {
  body: Schemas.CatalogRule;
} & ApiContext["fetcherOptions"];

export const fetchSetIncludedInQualityGovernance = (
  variables: SetIncludedInQualityGovernanceVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    SetIncludedInQualityGovernanceError,
    Schemas.CatalogRule,
    {},
    {},
    {}
  >({
    url: "/api/v2/quality/preferences/governance/included/",
    method: "post",
    ...variables,
    signal,
  });

export const useSetIncludedInQualityGovernance = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SetIncludedInQualityGovernanceError,
      SetIncludedInQualityGovernanceVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    SetIncludedInQualityGovernanceError,
    SetIncludedInQualityGovernanceVariables
  >({
    mutationFn: (variables: SetIncludedInQualityGovernanceVariables) =>
      fetchSetIncludedInQualityGovernance({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type GetExcludedFromQualityGovernanceError =
  Fetcher.ErrorWrapper<undefined>;

export type GetExcludedFromQualityGovernanceVariables =
  ApiContext["fetcherOptions"];

export const fetchGetExcludedFromQualityGovernance = (
  variables: GetExcludedFromQualityGovernanceVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.CatalogRule,
    GetExcludedFromQualityGovernanceError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/api/v2/quality/preferences/governance/excluded/",
    method: "get",
    ...variables,
    signal,
  });

export const getExcludedFromQualityGovernanceQueryKey = (
  variables: GetExcludedFromQualityGovernanceVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/api/v2/quality/preferences/governance/excluded/",
    operationId: "getExcludedFromQualityGovernance",
    variables,
  });

export const useGetExcludedFromQualityGovernance = <
  TData = Schemas.CatalogRule,
>(
  variables: GetExcludedFromQualityGovernanceVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.CatalogRule,
      GetExcludedFromQualityGovernanceError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/quality/preferences/governance/excluded/",
    operationId: "getExcludedFromQualityGovernance",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.CatalogRule,
    GetExcludedFromQualityGovernanceError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetExcludedFromQualityGovernance(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export const useSuspenseGetExcludedFromQualityGovernance = <
  TData = Schemas.CatalogRule,
>(
  variables: GetExcludedFromQualityGovernanceVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.CatalogRule,
      GetExcludedFromQualityGovernanceError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/quality/preferences/governance/excluded/",
    operationId: "getExcludedFromQualityGovernance",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.CatalogRule,
    GetExcludedFromQualityGovernanceError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchGetExcludedFromQualityGovernance(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type SetExcludedFromQualityGovernanceError =
  Fetcher.ErrorWrapper<undefined>;

export type SetExcludedFromQualityGovernanceVariables = {
  body: Schemas.CatalogRule;
} & ApiContext["fetcherOptions"];

export const fetchSetExcludedFromQualityGovernance = (
  variables: SetExcludedFromQualityGovernanceVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    SetExcludedFromQualityGovernanceError,
    Schemas.CatalogRule,
    {},
    {},
    {}
  >({
    url: "/api/v2/quality/preferences/governance/excluded/",
    method: "post",
    ...variables,
    signal,
  });

export const useSetExcludedFromQualityGovernance = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SetExcludedFromQualityGovernanceError,
      SetExcludedFromQualityGovernanceVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    SetExcludedFromQualityGovernanceError,
    SetExcludedFromQualityGovernanceVariables
  >({
    mutationFn: (variables: SetExcludedFromQualityGovernanceVariables) =>
      fetchSetExcludedFromQualityGovernance({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type ApiListUsersQueryParams = {
  filter?: string | null;
  /**
   * @default 1
   */
  startIndex?: number | null;
  /**
   * @default 100
   */
  count?: number | null;
};

export type ApiListUsersError = Fetcher.ErrorWrapper<undefined>;

export type ApiListUsersVariables = {
  queryParams?: ApiListUsersQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * List users in the workspace using SCIM 2.0.
 */
export const fetchApiListUsers = (
  variables: ApiListUsersVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SCIMListResponse,
    ApiListUsersError,
    undefined,
    {},
    ApiListUsersQueryParams,
    {}
  >({ url: "/api/v2/scim/Users/", method: "get", ...variables, signal });

export const apiListUsersQueryKey = (
  variables: ApiListUsersVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/api/v2/scim/Users/",
    operationId: "apiListUsers",
    variables,
  });

/**
 * List users in the workspace using SCIM 2.0.
 */
export const useApiListUsers = <TData = Schemas.SCIMListResponse,>(
  variables: ApiListUsersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SCIMListResponse,
      ApiListUsersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/scim/Users/",
    operationId: "apiListUsers",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.SCIMListResponse,
    ApiListUsersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListUsers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * List users in the workspace using SCIM 2.0.
 */
export const useSuspenseApiListUsers = <TData = Schemas.SCIMListResponse,>(
  variables: ApiListUsersVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.SCIMListResponse,
      ApiListUsersError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/scim/Users/",
    operationId: "apiListUsers",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.SCIMListResponse,
    ApiListUsersError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListUsers({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiCreateUserError = Fetcher.ErrorWrapper<undefined>;

export type ApiCreateUserVariables = {
  body: Schemas.SCIMUserCreate;
} & ApiContext["fetcherOptions"];

/**
 * Create a user using SCIM 2.0.
 */
export const fetchApiCreateUser = (
  variables: ApiCreateUserVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SCIMUserRead,
    ApiCreateUserError,
    Schemas.SCIMUserCreate,
    {},
    {},
    {}
  >({ url: "/api/v2/scim/Users/", method: "post", ...variables, signal });

/**
 * Create a user using SCIM 2.0.
 */
export const useApiCreateUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SCIMUserRead,
      ApiCreateUserError,
      ApiCreateUserVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.SCIMUserRead,
    ApiCreateUserError,
    ApiCreateUserVariables
  >({
    mutationFn: (variables: ApiCreateUserVariables) =>
      fetchApiCreateUser({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetUserPathParams = {
  /**
   * @format uuid
   */
  userId: string;
};

export type ApiGetUserError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetUserVariables = {
  pathParams: ApiGetUserPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get a user by ID using SCIM 2.0.
 */
export const fetchApiGetUser = (
  variables: ApiGetUserVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SCIMUserRead,
    ApiGetUserError,
    undefined,
    {},
    {},
    ApiGetUserPathParams
  >({
    url: "/api/v2/scim/Users/{userId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetUserQueryKey = (
  variables: ApiGetUserVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/api/v2/scim/Users/{userId}/",
    operationId: "apiGetUser",
    variables,
  });

/**
 * Get a user by ID using SCIM 2.0.
 */
export const useApiGetUser = <TData = Schemas.SCIMUserRead,>(
  variables: ApiGetUserVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.SCIMUserRead, ApiGetUserError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/scim/Users/{userId}/",
    operationId: "apiGetUser",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.SCIMUserRead,
    ApiGetUserError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetUser({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get a user by ID using SCIM 2.0.
 */
export const useSuspenseApiGetUser = <TData = Schemas.SCIMUserRead,>(
  variables: ApiGetUserVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.SCIMUserRead,
      ApiGetUserError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/scim/Users/{userId}/",
    operationId: "apiGetUser",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.SCIMUserRead,
    ApiGetUserError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetUser({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiUpdateUserPathParams = {
  /**
   * @format uuid
   */
  userId: string;
};

export type ApiUpdateUserError = Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateUserVariables = {
  body: Schemas.SCIMUserUpdate;
  pathParams: ApiUpdateUserPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Update a user using SCIM 2.0.
 */
export const fetchApiUpdateUser = (
  variables: ApiUpdateUserVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SCIMUserRead,
    ApiUpdateUserError,
    Schemas.SCIMUserUpdate,
    {},
    {},
    ApiUpdateUserPathParams
  >({
    url: "/api/v2/scim/Users/{userId}/",
    method: "put",
    ...variables,
    signal,
  });

/**
 * Update a user using SCIM 2.0.
 */
export const useApiUpdateUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SCIMUserRead,
      ApiUpdateUserError,
      ApiUpdateUserVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.SCIMUserRead,
    ApiUpdateUserError,
    ApiUpdateUserVariables
  >({
    mutationFn: (variables: ApiUpdateUserVariables) =>
      fetchApiUpdateUser({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiPatchUserPathParams = {
  /**
   * @format uuid
   */
  userId: string;
};

export type ApiPatchUserError = Fetcher.ErrorWrapper<undefined>;

export type ApiPatchUserVariables = {
  body: Schemas.SCIMPatch;
  pathParams: ApiPatchUserPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Patch a user using SCIM 2.0.
 */
export const fetchApiPatchUser = (
  variables: ApiPatchUserVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SCIMUserRead,
    ApiPatchUserError,
    Schemas.SCIMPatch,
    {},
    {},
    ApiPatchUserPathParams
  >({
    url: "/api/v2/scim/Users/{userId}/",
    method: "patch",
    ...variables,
    signal,
  });

/**
 * Patch a user using SCIM 2.0.
 */
export const useApiPatchUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SCIMUserRead,
      ApiPatchUserError,
      ApiPatchUserVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.SCIMUserRead,
    ApiPatchUserError,
    ApiPatchUserVariables
  >({
    mutationFn: (variables: ApiPatchUserVariables) =>
      fetchApiPatchUser({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiDeleteUserPathParams = {
  /**
   * @format uuid
   */
  userId: string;
};

export type ApiDeleteUserError = Fetcher.ErrorWrapper<undefined>;

export type ApiDeleteUserVariables = {
  pathParams: ApiDeleteUserPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Delete (disable) a user using SCIM 2.0.
 */
export const fetchApiDeleteUser = (
  variables: ApiDeleteUserVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiDeleteUserError,
    undefined,
    {},
    {},
    ApiDeleteUserPathParams
  >({
    url: "/api/v2/scim/Users/{userId}/",
    method: "delete",
    ...variables,
    signal,
  });

/**
 * Delete (disable) a user using SCIM 2.0.
 */
export const useApiDeleteUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiDeleteUserError,
      ApiDeleteUserVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiDeleteUserError,
    ApiDeleteUserVariables
  >({
    mutationFn: (variables: ApiDeleteUserVariables) =>
      fetchApiDeleteUser({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiListGroupsQueryParams = {
  filter?: string | null;
  /**
   * @default 1
   */
  startIndex?: number | null;
  /**
   * @default 100
   */
  count?: number | null;
};

export type ApiListGroupsError = Fetcher.ErrorWrapper<undefined>;

export type ApiListGroupsVariables = {
  queryParams?: ApiListGroupsQueryParams;
} & ApiContext["fetcherOptions"];

/**
 * List groups in the workspace using SCIM 2.0.
 */
export const fetchApiListGroups = (
  variables: ApiListGroupsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SCIMListResponse,
    ApiListGroupsError,
    undefined,
    {},
    ApiListGroupsQueryParams,
    {}
  >({ url: "/api/v2/scim/Groups/", method: "get", ...variables, signal });

export const apiListGroupsQueryKey = (
  variables: ApiListGroupsVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/api/v2/scim/Groups/",
    operationId: "apiListGroups",
    variables,
  });

/**
 * List groups in the workspace using SCIM 2.0.
 */
export const useApiListGroups = <TData = Schemas.SCIMListResponse,>(
  variables: ApiListGroupsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SCIMListResponse,
      ApiListGroupsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/scim/Groups/",
    operationId: "apiListGroups",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.SCIMListResponse,
    ApiListGroupsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListGroups({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * List groups in the workspace using SCIM 2.0.
 */
export const useSuspenseApiListGroups = <TData = Schemas.SCIMListResponse,>(
  variables: ApiListGroupsVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.SCIMListResponse,
      ApiListGroupsError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/scim/Groups/",
    operationId: "apiListGroups",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.SCIMListResponse,
    ApiListGroupsError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiListGroups({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiCreateGroupError = Fetcher.ErrorWrapper<undefined>;

export type ApiCreateGroupVariables = {
  body: Schemas.SCIMGroupCreate;
} & ApiContext["fetcherOptions"];

/**
 * Create a group using SCIM 2.0.
 */
export const fetchApiCreateGroup = (
  variables: ApiCreateGroupVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SCIMGroupRead,
    ApiCreateGroupError,
    Schemas.SCIMGroupCreate,
    {},
    {},
    {}
  >({ url: "/api/v2/scim/Groups/", method: "post", ...variables, signal });

/**
 * Create a group using SCIM 2.0.
 */
export const useApiCreateGroup = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SCIMGroupRead,
      ApiCreateGroupError,
      ApiCreateGroupVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.SCIMGroupRead,
    ApiCreateGroupError,
    ApiCreateGroupVariables
  >({
    mutationFn: (variables: ApiCreateGroupVariables) =>
      fetchApiCreateGroup({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiGetGroupPathParams = {
  /**
   * @format uuid
   */
  groupId: string;
};

export type ApiGetGroupError = Fetcher.ErrorWrapper<undefined>;

export type ApiGetGroupVariables = {
  pathParams: ApiGetGroupPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Get a group by ID using SCIM 2.0.
 */
export const fetchApiGetGroup = (
  variables: ApiGetGroupVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SCIMGroupRead,
    ApiGetGroupError,
    undefined,
    {},
    {},
    ApiGetGroupPathParams
  >({
    url: "/api/v2/scim/Groups/{groupId}/",
    method: "get",
    ...variables,
    signal,
  });

export const apiGetGroupQueryKey = (
  variables: ApiGetGroupVariables,
): reactQuery.QueryKey =>
  queryKeyFn({
    path: "/api/v2/scim/Groups/{groupId}/",
    operationId: "apiGetGroup",
    variables,
  });

/**
 * Get a group by ID using SCIM 2.0.
 */
export const useApiGetGroup = <TData = Schemas.SCIMGroupRead,>(
  variables: ApiGetGroupVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.SCIMGroupRead, ApiGetGroupError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/scim/Groups/{groupId}/",
    operationId: "apiGetGroup",
    variables,
  });
  const result = reactQuery.useQuery<
    Schemas.SCIMGroupRead,
    ApiGetGroupError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetGroup({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

/**
 * Get a group by ID using SCIM 2.0.
 */
export const useSuspenseApiGetGroup = <TData = Schemas.SCIMGroupRead,>(
  variables: ApiGetGroupVariables,
  options?: Omit<
    reactQuery.UseSuspenseQueryOptions<
      Schemas.SCIMGroupRead,
      ApiGetGroupError,
      TData
    >,
    "queryKey" | "queryFn"
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useApiContext(options);
  const queryKey = queryKeyFn({
    path: "/api/v2/scim/Groups/{groupId}/",
    operationId: "apiGetGroup",
    variables,
  });
  const result = reactQuery.useSuspenseQuery<
    Schemas.SCIMGroupRead,
    ApiGetGroupError,
    TData
  >({
    queryKey: queryKey,
    queryFn: ({ signal }) =>
      fetchApiGetGroup({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
  const compiled = result as typeof result & {
    queryKey: reactQuery.QueryKey;
  };
  compiled.queryKey = queryKey;
  return compiled;
};

export type ApiUpdateGroupPathParams = {
  /**
   * @format uuid
   */
  groupId: string;
};

export type ApiUpdateGroupError = Fetcher.ErrorWrapper<undefined>;

export type ApiUpdateGroupVariables = {
  body: Schemas.SCIMGroupUpdate;
  pathParams: ApiUpdateGroupPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Update a group using SCIM 2.0.
 */
export const fetchApiUpdateGroup = (
  variables: ApiUpdateGroupVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SCIMGroupRead,
    ApiUpdateGroupError,
    Schemas.SCIMGroupUpdate,
    {},
    {},
    ApiUpdateGroupPathParams
  >({
    url: "/api/v2/scim/Groups/{groupId}/",
    method: "put",
    ...variables,
    signal,
  });

/**
 * Update a group using SCIM 2.0.
 */
export const useApiUpdateGroup = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SCIMGroupRead,
      ApiUpdateGroupError,
      ApiUpdateGroupVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.SCIMGroupRead,
    ApiUpdateGroupError,
    ApiUpdateGroupVariables
  >({
    mutationFn: (variables: ApiUpdateGroupVariables) =>
      fetchApiUpdateGroup({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiPatchGroupPathParams = {
  /**
   * @format uuid
   */
  groupId: string;
};

export type ApiPatchGroupError = Fetcher.ErrorWrapper<undefined>;

export type ApiPatchGroupVariables = {
  body: Schemas.SCIMPatch;
  pathParams: ApiPatchGroupPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Patch a group using SCIM 2.0.
 */
export const fetchApiPatchGroup = (
  variables: ApiPatchGroupVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SCIMGroupRead,
    ApiPatchGroupError,
    Schemas.SCIMPatch,
    {},
    {},
    ApiPatchGroupPathParams
  >({
    url: "/api/v2/scim/Groups/{groupId}/",
    method: "patch",
    ...variables,
    signal,
  });

/**
 * Patch a group using SCIM 2.0.
 */
export const useApiPatchGroup = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SCIMGroupRead,
      ApiPatchGroupError,
      ApiPatchGroupVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.SCIMGroupRead,
    ApiPatchGroupError,
    ApiPatchGroupVariables
  >({
    mutationFn: (variables: ApiPatchGroupVariables) =>
      fetchApiPatchGroup({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type ApiDeleteGroupPathParams = {
  /**
   * @format uuid
   */
  groupId: string;
};

export type ApiDeleteGroupError = Fetcher.ErrorWrapper<undefined>;

export type ApiDeleteGroupVariables = {
  pathParams: ApiDeleteGroupPathParams;
} & ApiContext["fetcherOptions"];

/**
 * Delete a group using SCIM 2.0.
 */
export const fetchApiDeleteGroup = (
  variables: ApiDeleteGroupVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    undefined,
    ApiDeleteGroupError,
    undefined,
    {},
    {},
    ApiDeleteGroupPathParams
  >({
    url: "/api/v2/scim/Groups/{groupId}/",
    method: "delete",
    ...variables,
    signal,
  });

/**
 * Delete a group using SCIM 2.0.
 */
export const useApiDeleteGroup = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ApiDeleteGroupError,
      ApiDeleteGroupVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    undefined,
    ApiDeleteGroupError,
    ApiDeleteGroupVariables
  >({
    mutationFn: (variables: ApiDeleteGroupVariables) =>
      fetchApiDeleteGroup({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type QueryOperation =
  | {
      path: "/api/v2/resource/all_v2/{entityId}/stakeholders/";
      operationId: "apiGetEntityStakeholdersV2";
      variables: ApiGetEntityStakeholdersV2Variables;
    }
  | {
      path: "/api/v2/resource/all_v2/custom_properties/v2/";
      operationId: "listCustomPropertiesV2";
      variables: ListCustomPropertiesV2Variables;
    }
  | {
      path: "/api/v2/admin/metric/execution/{executionId}/";
      operationId: "apiSuperuserGetQueryBackgroundJob";
      variables: ApiSuperuserGetQueryBackgroundJobVariables;
    }
  | {
      path: "/api/v2/auth/teams/";
      operationId: "apiListTeamsV2";
      variables: ApiListTeamsV2Variables;
    }
  | {
      path: "/api/v2/auth/api_keys/";
      operationId: "apiListApiKeysV2";
      variables: ApiListApiKeysV2Variables;
    }
  | {
      path: "/api/v2/workspace/feature_access/v2/";
      operationId: "getWorkspaceFeatureAccess";
      variables: GetWorkspaceFeatureAccessVariables;
    }
  | {
      path: "/api/v2/auth/user/me/";
      operationId: "apiMe";
      variables: ApiMeVariables;
    }
  | {
      path: "/api/v2/auth/user/intercom-identity-token/";
      operationId: "apiGetIntercomIdentityToken";
      variables: ApiGetIntercomIdentityTokenVariables;
    }
  | {
      path: "/api/v2/workspace/seats/limits/";
      operationId: "apiGetWorkspaceLimits";
      variables: ApiGetWorkspaceLimitsVariables;
    }
  | {
      path: "/api/v2/workspace/billing/info/";
      operationId: "getBillingInfo";
      variables: GetBillingInfoVariables;
    }
  | {
      path: "/api/v2/integration_v2/integrations/catalogtree/list/";
      operationId: "apiCatalogTreeV3GetIntegrations";
      variables: ApiCatalogTreeV3GetIntegrationsVariables;
    }
  | {
      path: "/api/v2/integration_v2/slack/conversations/list/";
      operationId: "getSlackConversationsList";
      variables: GetSlackConversationsListVariables;
    }
  | {
      path: "/api/v2/query/queries/creation_query/{entityId}/";
      operationId: "apiGetCreationQueryV2";
      variables: ApiGetCreationQueryV2Variables;
    }
  | {
      path: "/api/v2/quality/preferences/governance/included/";
      operationId: "getIncludedInQualityGovernance";
      variables: GetIncludedInQualityGovernanceVariables;
    }
  | {
      path: "/api/v2/quality/preferences/governance/excluded/";
      operationId: "getExcludedFromQualityGovernance";
      variables: GetExcludedFromQualityGovernanceVariables;
    }
  | {
      path: "/api/v2/scim/Users/";
      operationId: "apiListUsers";
      variables: ApiListUsersVariables;
    }
  | {
      path: "/api/v2/scim/Users/{userId}/";
      operationId: "apiGetUser";
      variables: ApiGetUserVariables;
    }
  | {
      path: "/api/v2/scim/Groups/";
      operationId: "apiListGroups";
      variables: ApiListGroupsVariables;
    }
  | {
      path: "/api/v2/scim/Groups/{groupId}/";
      operationId: "apiGetGroup";
      variables: ApiGetGroupVariables;
    };
